export default "__VITE_ASSET__Bs2TnDbf__"